import modules from "@/app.default"
import {
  BooleanInput,
  Create,
  ReferenceInput,
  SelectInput,
  SimpleForm,
} from "@/components/admin"
import { ReactElement } from "react"

/*
const transformID = (formData: PermissionRecord) => {
  const { id, class_id, subject_id } = formData
  if (id) return formData
  return {
    ...formData,
    id: [class_id, subject_id].join('-'),
  }
}
*/

const ProgramCreate = (): ReactElement => {
  return (
    <Create redirect="list">
      <SimpleForm>
        <ReferenceInput
          source="user_id"
          reference="users"
          perPage={1000}
          sort={{ field: "first_name", order: "ASC" }}
        >
          <SelectInput optionValue="id" />
        </ReferenceInput>
        <SelectInput
          source="action"
          choices={[
            { id: "list", name: "Lister" },
            { id: "show", name: "Afficher" },
            { id: "edit", name: "Éditer" },
            { id: "create", name: "Créer" },
          ]}
        />
        <SelectInput source="resource" choices={Object.keys(modules)} />
        <BooleanInput source="allowed" />
      </SimpleForm>
    </Create>
  )
}

export default ProgramCreate
